export const getAccessCompaniesInitialState = {
	accessCompanies: null,
	error: null,
	errorShow: false,
	loading: false,
};
